<template>
	<div style="width: 100%;height: 100%;background: #f0f2f5;">
		<div style="width: 100%;">
            <LayoutHeader route="enterprise"/>
		</div>

		<div style="background: #f0f2f5;">
            <div class="banner-box">
                <img src="@/assets/home/zcdx-banner.png" alt="">
                <div class="text-box">
                    <div class="text1">政策兑现申报   ·   聚焦企业需求   ·   推动政策落地   ·   助力企业发展</div>
                    <div class="text2">政策兑现申报</div>
<!--                     <div class="button">查看我的申报</div>-->
                </div>
            </div>
            <div class="breadBox">
                <div class="child">
                    <a-breadcrumb>
            <span>
              当前位置：
            </span>
                        <a-breadcrumb-item style="cursor: pointer;" @click="this.$router.push('/')">首页
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>政策兑现</a-breadcrumb-item>
                    </a-breadcrumb>
                </div>
            </div>
			<a-card class="materializePolicy" style="padding:0;">
				<div class="top_title">
					<span class="title">政策兑现</span>

					<a-button @click="showApply()" type="primary" style="font-size:16px;height:40px;width:120px">申报查询</a-button>

					<!-- 用户申报 -->
					<a-modal width="800px" v-model:visible="visible" @cancel="changeClose" :title="modalTitle" :footer="null">
						<a-form layout="vertical" ref="ruleForm" :model="material" :rules="materialRules">
							<a-row :gutter="[24, 8]">
								<div class="hidden">
									<a-form-item label="id" name="id">
										<a-input style="width:100%" v-model:value="material.id" />
									</a-form-item>

									<a-form-item label="companyCode" name="companyCode">
										<a-input style="width:100%" v-model:value="material.companyCode" />
									</a-form-item>
								</div>
								<a-col v-show="modalShowType == 'addShow'" :span="24">
									<div class="filePost">
										<h3 style="
																									display: inline-block;
																									width:100%;
																									font-weight: 600;
																									padding:5px 0;
																									margin-bottom: 10px;
																									font-size: 18px;
																									border-bottom: 3px solid #222;">申报材料提供</h3>
									</div>
								</a-col>

								<a-col v-show="modalShowType == 'addShow'" :span="12" v-for="item in material" :key="item" name="businessLicense">

									<a-form-item>
										<template #label>
											<span><span v-if="!item.isMust" style="color: red;margin-right:5px">*</span>{{
												item.dataName }}</span>
											<a-button size="small" v-if="item.dataTemplate"
												style="background: #a8a8a8; margin-left:20px;position:relative;overflow:hidden; border:1px solid #a8a8a8"
												type="primary">
												材料说明
												<file-upload style="position:absolute;opacity:0; top:-4px;left:0"
													v-model:value="item.dataTemplate" :showBtn="false" disabled />
											</a-button>
										</template>

										<file-upload style="float:left; height: 40px;" v-model:value="item.registrationForm" :size="800"
											:isPdfImg="true" />
									</a-form-item>
								</a-col>

								<a-col v-show="modalShowType == 'addShow'" :span="12">
									<a-form-item label="企业名称" name="companyName">
											<a-input v-model:value="material.companyName" placeholder="请输入企业名称" />
									</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'addShow'" :span="12">
									<a-form-item label="法人代表" name="companyCorporate">
											<a-input v-model:value="material.companyCorporate" placeholder="请输入法人代表" />
									</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'addShow'" :span="12">
									<a-form-item label="统一社会应用代码" name="companyLicence">
											<a-input v-model:value="material.companyLicence" placeholder="请输入统一社会应用代码" />
											</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'addShow'" :span="12">
									<a-form-item label="企业注册地" name="companyAddress">
											<a-input v-model:value="material.companyAddress" placeholder="请输入企业注册地" />
											</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'addShow'" :span="12">
									<a-form-item label="经办人" name="agent">
											<a-input v-model:value="material.agent" placeholder="请输入经办人" />
											</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'addShow'" :span="12">
									<a-form-item label="经办人联系方式" name="agentPhone">
											<a-input v-model:value="material.agentPhone" placeholder="请输入经办人联系方式" />
											</a-form-item>
							</a-col>
								<a-col v-show="modalShowType == 'addShow'" :span="24">
									<a-form-item name="action" label=" " style="text-align:center">
										<a-button style="margin-right:20px" @click="SealPost(3, 'ListShow')">申报</a-button>
										<a-button @click="modalShowBack">取消</a-button>
									</a-form-item>
								</a-col>

								<!-- 申报材料详情 -->
								<a-col v-show="modalShowType == 'detailShow'" :span="24">
									<div class="filePost">
										<h3 style="
																									display: inline-block;
																									width:100%;
																									font-weight: 600;
																									padding:5px 0;
																									margin-bottom: 10px;
																									font-size: 18px;
																									border-bottom: 3px solid #222;">申报材料详情</h3>
									</div>
								</a-col>

								<a-col v-show="modalShowType == 'detailShow'" :span="12" v-for="item in material" :key="item" name="businessLicense">

									<a-form-item>
										<template #label>
											<span><span v-if="!item.isMust" style="color: red;margin-right:5px">*</span>{{
												item.dataName }}</span>
											<a-button size="small" v-if="item.dataTemplate"
												style="background: #a8a8a8; margin-left:20px;position:relative;overflow:hidden; border:1px solid #a8a8a8"
												type="primary">
												材料说明
												<file-upload style="position:absolute;opacity:0; top:-4px;left:0"
													v-model:value="item.dataTemplate" :showBtn="false" disabled />
											</a-button>
										</template>

										<file-upload style="float:left; height: 40px;" v-model:value="item.registrationForm" :size="800"
											:isPdfImg="true" :showBtn="false" disabled/>
									</a-form-item>
								</a-col>

								<a-col v-show="modalShowType == 'detailShow'" :span="12">
									<a-form-item label="企业名称" name="companyName">
											<a-input v-model:value="material.companyName" placeholder="请输入企业名称" disabled/>
									</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'detailShow'" :span="12">
									<a-form-item label="法人代表" name="companyCorporate">
											<a-input v-model:value="material.companyCorporate" placeholder="请输入法人代表" disabled/>
									</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'detailShow'" :span="12">
									<a-form-item label="统一社会应用代码" name="companyLicence">
											<a-input v-model:value="material.companyLicence" placeholder="请输入统一社会应用代码" disabled/>
											</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'detailShow'" :span="12">
									<a-form-item label="企业注册地" name="companyAddress">
											<a-input v-model:value="material.companyAddress" placeholder="请输入企业注册地" disabled/>
											</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'detailShow'" :span="12">
									<a-form-item label="经办人" name="agent">
											<a-input v-model:value="material.agent" placeholder="请输入经办人" disabled/>
											</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'detailShow'" :span="12">
									<a-form-item label="经办人联系方式" name="agentPhone">
											<a-input v-model:value="material.agentPhone" placeholder="请输入经办人联系方式" disabled/>
											</a-form-item>
							</a-col>
							<a-col v-show="modalShowType == 'detailShow'" :span="24">
								<a-form-item name="action" label=" " style="text-align:center">
									<!-- <a-button style="margin-right:20px" @click="SealPost(3, 'ListShow')">申报</a-button> -->
									<a-button @click="modalShowBack">返回</a-button>
								</a-form-item>
							</a-col>
								<!-- 申报查询列表 -->
								<a-col v-show="modalShowType == 'ListShow'" :span="24">
									<div class="filePost">
										<h3 style="
																									display: inline-block;
																									width:100%;
																									font-weight: 600;
																									padding:5px 0;
																									margin-bottom: 10px;
																									font-size: 18px;
																									border-bottom: 3px solid #222;">申报查询列表</h3>
									</div>
								</a-col>
								<a-col v-show="modalShowType == 'ListShow'" :span="24">
									<a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading"
										@change="onTableChange">
										<template #policyTitle="{ record }">
											<span>{{ record.policyTitle }}</span>
										</template>
										<template #matterName="{ record }">
											<a @click="modelPagelistOnEdit(record.polictDataId,'detailShow')">{{ record.matterName }}</a>
										</template>
										<template #schedule="{ record }">
											<span v-if="record.schedule == 1">待提交</span>
											<span v-if="record.schedule == 2">审核中</span>
											<span style="color:green" v-if="record.schedule == 3">审核通过</span>
											<a-popover placement="bottom">
												<template #content>
													<p>未通过理由:{{ record.reason }}</p>
												</template>
												<span style="color:red" v-if="record.reason">(审核未通过)</span>
											</a-popover>

											<a  v-if="record.schedule > 1" @click="processPagelist(record.polictDataId)" style="font-size:10px"> [查看进度]</a>
										</template>
										<template #action="{ record }">
											<!-- <a @click="onDetail(record)">详情 </a> -->
											<a v-if="record.schedule == 1" @click="modelPagelistSubmit(record.polictDataId)"> 提交</a>
											<a v-if="record.schedule == 1" @click="modelPagelistOnEdit(record.polictDataId,'addShow')"> 编辑</a>
											<a v-if="record.schedule == 1" @click="modelPagelistDelete(record.polictDataId)"> 删除</a>
											<a v-if="record.schedule > 1" @click="modelPagelistOnEdit(record.polictDataId,'detailShow')"> 详情</a>
										</template>
									</a-table>

								</a-col>


								<a-col v-show="modalShowType == null" :span="24">
									<h3 style="
																							display: inline-block;
																							width:100%;
																							font-weight: 600;
																							padding:5px 0;
																							margin-bottom: 10px;
																							font-size: 18px;
																							border-bottom: 3px solid #222;">用户信息确认</h3>
								</a-col>
								<a-col v-show="modalShowType == null" :span="24">

									<a-modal v-model:visible="isShow" title="请填写当前计算式的答案" @ok="valiKaptcha">
										<img style="float:left" @click="subPhone" :src="kaptcha" alt="">
										<a-input style="width:120px;margin-left:50px;font-size:22px;height:50px" v-model:value="kaptchanum"
														placeholder="答案" />
									</a-modal>
									<a-form-item :label-col="{ style: 'width:90px' }" name="phoneNumber" label="手机号"
										style="text-align:center;width:60%;margin:0 auto">
										<a-input style="position:relative;margin-right:20px;" v-model:value="material.phoneNumber"
											placeholder="请输入手机号">
											<template #prefix>
												<PhoneOutlined class="tc-gray" />
											</template>
											<template #addonAfter>
												<a-botton style="cursor: pointer;" @click="subPhone()">{{ codeBtnWord
												}}</a-botton>
												<div class="codeBtnWordMark" ref="codeBtnWordMarkid">

												</div>
											</template>
										</a-input>
									</a-form-item>
								</a-col>
								<a-col v-show="modalShowType == null" :span="24">
									<a-form-item name="watmal" label="手机验证码" style="text-align:center;width:60%;margin:0 auto">
										<a-input style="margin-right:20px;" v-model:value="material.watmal" placeholder="请输入手机验证码">
											<template #prefix>
												<LockOutlined class="tc-gray" />
											</template>
										</a-input>
									</a-form-item>
								</a-col>
								<a-col v-show="modalShowType == null" :span="24">
									<a-form-item name="action" label=" " style="text-align:center">
										<!-- <a-button style="margin-right:20px" @click="SealPost(1, 'addShow')">去申报兑现</a-button> -->
										<a-button style="margin-right:20px" @click="SealPost(2, 'ListShow')">申报查询</a-button>
										<a-button @click="modalShowBack">取消</a-button>
									</a-form-item>
								</a-col>
							</a-row>
						</a-form>
					</a-modal>
					<a-modal @cancel="poressShow=false" @ok="poressShow=false" title="详情" :visible="modalShowType == 'ListShow'&&poressShow" class="poress">
						<div class="cardMash" @click="closePoressShow"></div>
						<a-card class="cardMian">
<!--							<a-steps progress-dot direction="vertical" size="small" :current="1">
								<a-step v-for="item in detailShowItem" :key="item" :title="item">
									<template #description>
										<div v-for="(child,key) in detailShowMian[item]" :key="key">
											<span style="margin-right:20px;">{{child.processName}}</span>
											<span style="color:rgb(148, 148, 148)" v-if="child.checkStatus==null">未审核</span>
											<span style="color:green" v-if="child.checkStatus==0">审核通过</span>
											<span style="color:red" v-if="child.checkStatus==1">审核未通过</span>
											<span v-if="child.checkStatus==0" style="margin-left:20px;">{{child.updatedTime}}</span>
										</div>
									</template>
								</a-step>
							</a-steps>-->
                            <a-timeline>
                                <a-timeline-item v-for="item in detailShowItem" :key="item">
                                    <div><b>{{item}}</b></div>
                                    <div v-for="child in detailShowMian[item]" :key="child.id">
                                        <span style="margin-right:20px">{{ child.processName }}</span>
                                        <span v-if="child.checkStatus==null">未审核</span>
                                        <span v-if="child.checkStatus==0">审核通过</span>
                                        <span v-if="child.checkStatus==1">审核未通过</span>
<!--                                        <span style="margin-left:20px">{{ child.updatedTime }}</span>-->
                                    </div>
                                </a-timeline-item>
                            </a-timeline>
						</a-card>
					</a-modal>
					<!-- <span class="serch">
											<a-input-search
											v-model:value="value"
											placeholder="请输入专项名称"
											style="width: 200px;height:30px"
											@search="onSearch"
										/>
										</span> -->
				</div>
				<!-- <div class="tip_cont">
										<span style="margin-right:20px">排序选择</span>
										<a-button :class="{activeBtn:tipShow==0}" @click="tipShowFn(0)" size="small">最新<ArrowDownOutlined /></a-button>
										<a-button :class="{activeBtn:tipShow==1}" @click="tipShowFn(1)" size="small">时间<ArrowDownOutlined /></a-button>
										<a-button :class="{activeBtn:tipShow==2}" @click="tipShowFn(2)" size="small">热度<ArrowDownOutlined /></a-button>
										<span style="flex:1"></span>
										<span>共209条记录</span>
									</div> -->
				<div class="contbody">
					<ul>
						<a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="form">
							<template #renderItem="{ item }">
								<li @click="goMore('/materializePolicy/Detail', item.subjectId)">
									<h5>{{ item.matterName }}</h5>
									<div class="cont_tip">
										<span v-if="item.declareStartTime && item.declareEndTime" class="redtip">
											{{ calculateDaysDifference(item.declareStartTime, item.declareEndTime) }}
										</span>
										<span v-else class="bluetip">
											长期
										</span>
									</div>
                                    <div class="button-box">
                                        <div class="button">立即申报</div>
                                    </div>
								</li>
							</template>
						</a-list>

						<!-- <li @click="goMore('/materializePolicy/Detail','0')">
												<h5>2022年度生物医药产业政</h5>
												<div class="cont_tip">
													<span class="redtip">剩14天</span>
													<span class="bluetip">资金支持</span>
												</div>
												<div class="botom_msg">
													<span class="botcon"></span>
													<span>971看过</span>
												</div>
											</li> -->





					</ul>
				</div>


			</a-card>
		</div>
		<LayoutFooter />
	</div>
</template>
<script>
import { message } from 'ant-design-vue';
import { ls } from "@/utils/util"
import { phoneCommon } from "@/api/finance"
import { notification } from "ant-design-vue";
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import LayoutHeader from '@/layout/layoutPage/header/LayoutHeaderNew2';
import { file_service } from "@/api/adminService";
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { kaptcha } from "@/api/adminService";
import { policySubject, policyData, policyCompany, processPolicy, policyCompanyData, jwtToken } from "@/api/materializePolicy";
import { SealService } from "@/config/variableConfig";
import axios from "axios";

const pagination = {
	pageSize: 10,
	showQuickJumper: true,
};

const columns = [
	// {
	// 	title: "政策标题",
	// 	dataIndex: 'policyTitle',
	// 	key: 'policyTitle',
	// 	slots: {
	// 		customRender: 'policyTitle',
	// 	},
	// },
	{
		title: "事项名称",
		dataIndex: 'matterName',
		key: 'matterName',
		slots: {
			customRender: 'matterName',
		},
	},

	{
		title: "状态",
		dataIndex: 'schedule',
		key: 'schedule',
		slots: {
			customRender: 'schedule',
		},
	},

	{ title: "操作", fixed: 'right', dataIndex: "action", key: "action", slots: { customRender: "action" } },
]
export default {
	name: "AddOrEditModal",
	components: {
		LayoutFooter,
        LayoutHeader
	},

	mixins: [formMixin],
	data() {
		return {
			detailShowMian:[],
			detailShowItem:[],
			poressShow:false,
			kaptcha: null,
			kaptchanum: null,
			columns,
			isShow: false,
			dataSource: [],
			codeBtnWord: '获取短信验证码',
			form: null,
			material: {
				phoneNumber: null,
				watmal: null,
				companyName: null,
				companyCorporate: null,
				companyLicence: null,
				companyAddress: null,
				agent: null,
				agentPhone: null,
			},
			materialRules: {
				phoneNumber: [
					dataCheck.required({ msg: '手机号不能为空' }), dataCheck.mobile_phone
				],
				watmal: [
					dataCheck.required({ msg: '验证码不能为空' }),
				],
				companyName: [
						dataCheck.required({}),
				],
				companyCorporate: [
						dataCheck.required({}),
				],
				companyLicence: [
						dataCheck.required({}),
				],
				companyAddress: [
						dataCheck.required({}),
				],
				agent: [
						dataCheck.required({}),
				],
				agentPhone: [
						dataCheck.required({}),dataCheck.phone
				],
			},
			modalShowType: null,
			visible: false,
			pagination,
			current: 1,
			pageSize: 10,
			SealService,
			platformName,
			all_logo: '',
			tipShow: 0,
			jwtToken: null,
		}
	},
	mounted() {
		this.all_logo = this.$ls.get('all_logo');
		this.getFormData()
	},
	methods: {

		/**
		 * @description: 防机器刷，并获取验证码
		 * @return {*}
		 */
		subPhone() {
			axios({
				method: 'get',
				url: kaptcha.generatekaptcha,
				responseType: 'blob',
				params: {
					phone: this.form.phoneNumber
				}
			}).then(res => {
				const blob = new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8" });
				this.kaptcha = window.URL.createObjectURL(blob)
				this.isShow = true;
			})
		},
		valiKaptcha() {
			// this.subPhone()
			axios({
				method: 'get',
				url: kaptcha.verifykaptcha,
				params: {
					phone:this.form.phoneNumber,
					num:this.kaptchanum
				}
			}).then(res => {
				if(res.data.data){
					this.isShow = false;
					this.getPhoneCode()
				}else{
					this.subPhone()
					message.warning ('请重新计算，答案错误');
				}
			})

		},
		/**
		 * @description: 获取验证码
		 * @return {*}
		 */
		getPhoneCode() {
			this.$refs.ruleForm
				.validate('phoneNumber')
				.then((value) => {
					this.postAction({
						url: phoneCommon.sealSMS,
						params: {
							phone: value.phoneNumber
						}
					}
					).then((res) => {
						if (res.code == '0') {
							this.waitTime = (res.msg * 60) + 1
							this.waitTime--;
							this.$refs.codeBtnWordMarkid.style.zIndex = 1
							this.codeBtnWord = `${this.waitTime}s 后获取`;
							let timer = setInterval(() => {
								if (this.waitTime > 1) {
									this.waitTime--;
									this.codeBtnWord = `${this.waitTime}s 后获取`;
								} else {
									clearInterval(timer);
									this.codeBtnWord = "获取短信验证码";
									this.$refs.codeBtnWordMarkid.style.zIndex = -1
									this.waitTime = 61;
								}
							}, 1000);
							notification.success({
								message: '验证码发送成功，请查看手机短信',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '1') {
							notification.success({
								message: '验证码发送失败，请稍后重新发送',
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '2') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						} else if (res.code == '3') {
							notification.success({
								message: res.msg,
								style: {
									width: '400px',
									fontWeight: '600',
									marginLeft: `${-200}%`,
									marginTop: `${20}%`,
								}
							});
						}
					})
				})
		},
		/**
		 * @description: 校验JWT
		 * @return {*}
		 */
		valiJWT() {
			this.getAction({
				url: jwtToken.JwtCheck,
				params: {
					phone: ls.get('jwtphone'),
					jwt: ls.get('jwtMain')
				}
			}).then((res) => {
				if (res) {
					this.modalListShow()
				} else {
					this.visible = true
				}
			})
		},
		/**
		 * @description: 获取JWT
		 * @param {*} m
		 * @return {*}
		 */
		getJWT(m) {
			this.getAction({
				url: jwtToken.phoneGetJwt,
				params: {
					phone: ls.get('jwtphone')
				}
			}).then((res) => {
				if (res) {
					ls.set('jwtMain', res)
					this.jwtToken = res

					setTimeout(() => {
						if (m == 'addShow') {
							this.polictDataId = null
							this.modalShowType = m

						} else if (m == 'ListShow') {
							this.modalShowType = m
							this.modalListShow()
						}
					}, 500);
				}
			}).catch((errer) => {
				console.log(errer.msg)
			})
		},
		/**
		 * @description: 封装JWT heaers 函数
		 * @param {*} method
		 * @param {*} url
		 * @param {*} params
		 * @param {*} fun
		 * @return {*}
		 */
		getAxios(method, url, params, fun) {
			axios({
				method: method,
				headers: {
					AuthenticationPhone: ls.get('jwtphone'),
					AuthenticationJwt: ls.get('jwtMain')
				},
				url: url,
				params: params
			}).then(res => {
				if (res) {
					fun(res)
				}
			}).catch(() => {
				this.visible = false
				notification.warning({
					message: '登录过期',
					style: {
						width: '400px',
						fontWeight: '600',
						marginLeft: `${-200}%`,
						marginTop: `${20}%`,
					}
				});
				this.modalShowType = null
				setTimeout(() => {
					this.visible = true
				}, 50);
			})
		},
		/**
		 * @description: 查询按钮
		 * @return {*}
		 */
		showApply(subjectIdata) {
			this.getAction({
				url: policyData.policyListData,
				params: { subjectId: this.$route.query.id ? this.$route.query.id : subjectIdata }
			}).then((res) => {
				if (res) {
					this.material = res
					if (!this.polictDataId) {
						this.valiJWT()
					} else {
						this.modalShowType = 'ListShow'
						this.visible = true
					}
				}
			})
		},
		calculateDaysDifference(n, m) {
			const start = new Date(n);
			const end = new Date(m);
			const diff = end - start;
			const days = Math.floor(diff / (1000 * 60 * 60 * 24));
			return days ? `还剩${days}天` : `已过期`
		},
		/**
		 * @description: 提交去申报/查询
		 * @param {*} n
		 * @param {*} m
		 * @return {*}
		 */
		SealPost(n, m) {
			if (n == 3) {
				let arr = []
				for (let index = 0; index < this.material.length; index++) {
					arr.push(this.material[index].registrationForm);
				}
				this.form.materialId = arr.toString()
                var valiSomeone = ['companyName','companyCorporate', 'companyLicence', 'companyAddress', 'agent', 'agentPhone']
                this.$refs.ruleForm.validate(valiSomeone).then(() => {
                    this.modalAddUpdata()
                }).catch(error => {
                        if(error.errorFields.length){
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                            window.console.log('error', error);
                        }
                    });
			} else {
				var valiSome = ['watmal', 'phoneNumber']
				this.$refs.ruleForm.validate(valiSome).then(() => {

					this.postAction({
						url: phoneCommon.sealSMSCheck,
						params: {
							code: this.material.watmal,
							phone: this.material.phoneNumber
						}
					}
					).then((res) => {
						if (res) {
							this.$notification.success({
								message: '验证码正确，请继续操作',
								duration: 10,
								style: {
									width: '400px',
									fontWeight: '600',
									marginTop: `${10}%`,
								},
							});

				this.getAction({
					url: policyCompany.doPhone,
					params: {
						companyPhone: this.material.phoneNumber
					}
				}).then((res) => {
					if (res) {
						ls.set('jwtphone', res.companyPhone);

						this.form.companyPhone = res.companyPhone
						this.form.companyId = res.companyId
						this.form.subjectId = this.$route.query.id
						this.getJWT(m)

					}
				})


				} else {
					this.$notification.error({
						message: '验证码有误，请输入正确验证码',
						duration: 10,
						style: {
							width: '400px',
							fontWeight: '600',
							marginTop: `${10}%`,
						},
					});
				}
					})

				})
			}
		},

		/**
		 * 去申报
		 */
		modalAddUpdata() {
			if (this.polictDataId) {

				this.getAxios('post', policyCompanyData.updatePCData, {
					companyPhone: this.form.companyPhone ? this.form.companyPhone : ls.get('jwtphone'),
					companyId: this.form.companyId,
					subjectId: this.$route.query.id,
					materialId: this.form.materialId,
					polictDataId: this.polictDataId,
					companyName: this.material.companyName,
					companyCorporate:this.material.companyCorporate,
					companyLicence:this.material.companyLicence,
					companyAddress:this.material.companyAddress,
					agent:this.material.agent,
					agentPhone:this.material.agentPhone
				}, (res) => {
					if (res) {
						this.modalListShow()
					}
				})
			} else {

				this.getAxios('post', policyCompanyData.addPCData, {
					companyPhone: this.form.companyPhone ? this.form.companyPhone : ls.get('jwtphone'),
					companyId: this.form.companyId,
					subjectId: this.$route.query.id,
					materialId: this.form.materialId,
					companyName: this.material.companyName,
					companyCorporate:this.material.companyCorporate,
					companyLicence:this.material.companyLicence,
					companyAddress:this.material.companyAddress,
					agent:this.material.agent,
					agentPhone:this.material.agentPhone
				}, (res) => {
					if (res) {
						this.modalListShow()
					}
				})
			}
		},
		/**
		 * @description: 列表展示
		 * @param {*} del
		 * @return {*}
		 */
		modalListShow(del) {

			this.loading = true;
			if (del) {
				this.polictDataId = null
			}

			this.getAxios('get', policyCompanyData.selectByPage, {
				companyPhone: ls.get('jwtphone'),
			}, (res) => {
				this.modalShowType = 'ListShow'
				this.visible = true
				setTimeout(() => {
					this.loading = false;
					this.dataSource = res.data.data.records
				}, 50);
			})
		},

  /**
   * @description: 申请流程
   * @param {*} id
   * @return {*}
   */
		processPagelist(id) {
		this.polictDataId = id
		this.getAxios('get', processPolicy.selectProcessList, {
			submitId: id,
			checkStatus: 1,
		}, (res) => {
			if(res.data.data){
				// 设置弹窗的样式
				document.querySelector('.ant-modal-body').style.overflowY = 'hidden'
				document.querySelector('.ant-modal-body').style.height = '70vh'

				this.detailShowMian = res.data.data
				this.detailShowItem = Object.keys(res.data.data)
				this.poressShow=true
			}
		})
	},
 /**
  * @description: 关闭流程窗口
  * @return {*}
  */
	closePoressShow(){
			this.poressShow=false
			document.querySelector('.ant-modal-body').style.overflowY = 'auto'
	},
  /**
   * @description: 列表提交
   * @param {*} id
   * @return {*}
   */
		modelPagelistSubmit(id) {
			this.polictDataId = id
			this.getAxios('get', policyCompanyData.submitCompanyData, {
				polictDataId: id,
			}, (res) => {
				if (res) {
					this.modalListShow()
					notification.success({
						message: '提交成功'
					});
				}
			})
		},
		modelPagelistOnEdit(id,show) {
			this.polictDataId = id

			this.getAxios('get', policyCompanyData.detail, {
				polictDataId: id,
			}, (res) => {
				if (res) {
					this.showApply(res.data.data.subjectId)
					setTimeout(() => {
						let arr = res.data.data.materialId.split(",");
						for (let index = 0; index < arr.length; index++) {
							this.material[index].registrationForm = arr[index];
						}

						this.form.companyPhone = res.data.data.companyPhone
						this.material.companyName = res.data.data.companyName,
						this.material.companyCorporate = res.data.data.companyCorporate,
						this.material.companyLicence = res.data.data.companyLicence,
						this.material.companyAddress = res.data.data.companyAddress,
						this.material.agent = res.data.data.agent,
						this.material.agentPhone = res.data.data.agentPhone
						if( show=='detailShow'){
							this.modalShowType = 'detailShow'
						}else if(show == 'addShow'){
							this.modalShowType = 'addShow'
						}
					}, 500);
				}
			})


		},




		modelPagelistDelete(id) {
			this.dataSource = []

			this.getAxios('get', policyCompanyData.deleteById, {
				polictDataId: id,
			}, (res) => {
				if (res) {
					this.modalListShow()
					notification.success({
						message: '删除成功'
					});
				}
			})
		},
		// 申报编辑返回按钮
		modalShowBack() {
			if (this.polictDataId) {
				this.modalListShow('del')
			} else {
				this.changeClose()
			}

		},
		// 右上角关闭按钮
		changeClose() {
			this.onClose()
			this.poressShow = false
			setTimeout(() => {
				this.modalShowType = null
			}, 50);
		},
		tipShowFn(n) {
			this.tipShow = n
		},
		goMore(url, str) {
			this.$router.push({ path: url, query: { id: str } })
		},
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},
		getFormData() {
			this.getAction({
				url: policySubject.pageList,
				params: {
					current: 1,
					pageSize: 10,
				}
			}).then((res) => {
				this.form = res.records
			})
		},

	},
	beforeCreate() {
		// 修改背景色
		document.querySelector('body').setAttribute('style', 'background-color:#fff')
	}
	,
	beforeUnmount() {
		// 销毁背景色
		document.querySelector('body').removeAttribute('style')
	},
}
</script>
<style scoped lang="less">
:deep(.ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content){
	width: 400px;
}

/*.poress{
	position:absolute;
	display:flex;
	align-items: center;
	top:-13px;
	left:8px;
	right:0;
	margin:0 auto;
	width:67%;
	z-index: 999;
	height:70vh;
	.cardMash{
		position: absolute;
		background: #666666a8;
		z-index: 2;
		width:100%;
		height:100%;
	}
	.cardMian{
		display:flex;
		align-items: center;
		justify-content: center;
		margin:0 auto;
		:deep(.ant-card-body){
			padding-bottom: 24px;
		}
		z-index: 5;
		position:relative;
		background: #fff;
	}
}*/
.breadBox {
	width: 1200px;
	margin: 0 auto;
	padding: 20px 0;
}

:deep(.ant-list-pagination) {
	display: flex;
    justify-content: center;
}

/*:deep(.ant-card-body) {
	padding-bottom: 50px;
    background: #f0f2f5;
}*/

::v-deep .ant-pagination-item-active{
    background: #0059b5;
    border:none;
}
::v-deep .ant-pagination-item-active a{
    color: #fff;
}

/*::v-deep .ant-card-body{
    padding:24px 0;
}*/

.materializePolicy {
    width: 1200px;
    margin:0 auto 30px auto;
	color: #222;
    padding:0 !important;
	font-family: Helvetica Neue For Number, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
	background-color:#f0f2f5;
	.pagination {
		position: absolute;
		bottom: 20px;
		right: 20px;
	}

	.top_title {
		display: flex;
		//border-bottom: 3px solid #333333;
		padding-bottom: 2px;
        background: #fff;
        padding:10px 20px;

		.title {
			flex: 1;
			font-size: 22px;
			font-weight: 600;
		}

		.serch {
			flex: 1;
			display: flex;

			:deep(.ant-input-search) {
				margin-left: auto
			}
		}
	}

	.tip_cont {
		display: flex;
		margin-top: 15px;
		padding: 4px 0;

		button {
			margin-right: 5px;
			font-size: 12px;
			line-height: 20px;
		}

		.activeBtn {
			color: #fff;
			background: #40a9ff;
			border: 1px solid #40a9ff;
		}
	}
::v-deep .ant-list-items{
    display: flex;
    flex-wrap: wrap;
}
	.contbody {
		margin-top: 20px;

		ul {
            width: 100%;
            li:nth-child(3n){
                margin-right: 0;
            }
			li {
				width: 32%;
                background: #fff;
				margin-right: 22px;
				border-radius: 4px;
				margin-bottom: 1.25rem;
				padding: 1.25rem;
				position: relative;
                border:1px solid #fff;
                .button-box{
                    display: flex;
                    justify-content: flex-end;
                    margin:20px 0 0 0;
                    .button{
                        width: 100px;
                        height: 40px;
                        border:1px solid #0059B5;
                        border-radius: 4px;
                        font-size: 18px;
                        color: #0059B5;
                        text-align: center;
                        line-height: 40px;
                    }
                    .button:hover{
                        background: linear-gradient(90deg, #FF8F14, #FF5C0A);
                        box-shadow: 0px 0px 13px 0px #FFFFFF;
                        color: #FFFFFF;
                        border:1px solid #FF5C0A;
                    }
                }

				h5 {
					display: inline-block;
					height: 50px;
                    font-weight: bold;
                    font-size: 20px;
                    color: #333333;
					word-break: break-all;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				}

				.cont_tip {
					font-size: .8125rem;
					margin: 0;
                    border-bottom: 1px solid #DEDEDE;
                    padding-bottom: 26px;

					span {
						margin-right: 5px;
						padding: 0.15625rem 0.375rem
					}

					.defaultip {
						border: 0.0625rem solid #9aa0a3;
						color: #9aa0a3;
					}

					.redtip {
						border: 0.0625rem solid #fd3938;
						color: #fd3938;
					}

					.bluetip {
						border: 0.0625rem solid #FF8E14;
						color: #FF8E14;
                        background: #fff9f3;
					}
				}

				.botom_msg {
					display: flex;

					.botcon {
						flex: 1;
						padding-right: 20px;
						word-break: break-all;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
					}
				}
			}

			li:nth-child(3n) {
				margin-right: 0;
			}

			li:hover {
				transition: all 0.2s ease;
				cursor: pointer;
				border:1px solid #0059B5;

				h5 {
					color: #0059B5;
				}

				//.cont_tip {
				//	span {
				//		color: #fff !important;
				//		border: 1px solid #fff;
				//	}
				//}

				//.botom_msg {
				//	span {
				//		color: #fff !important;
				//	}
				//}
			}
		}
	}
}

.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			cursor: pointer;
			overflow: hidden;
			float: left;
			line-height: 92px;
			font-size: 30px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 66px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			float: right;
			display: flex;
			justify-content: space-around;
			line-height: 92px;
			font-size: 16px;

			a {
				font-weight: 600;
			}

			.loginBox {
				// float: left;
				cursor: pointer;
			}

			.loginBox:hover {
				color: #fc550b;
			}

			.lineBox {
				height: 18px;
				top: 36px;
			}

			.resigierBox {
				cursor: pointer;
				// float: left;
			}

			.resigierBox:hover {
				color: #fc550b;
			}
		}
	}
}

.bannerBox {
	position: relative;
	width: 100%;

	:deep(.ant-carousel) {
		position: relative;
		width: 100%;
	}

	.bannerImg {
		width: 100%;
		height: 282px;

		img {
			width: 100%;
			object-fit: cover;
			height: 280px;
		}
	}
}



.floatBox {
	width: 100%;

	.textBox {
		width: 100%;
		height: 250px;
		background-image: url('../../../assets/img/resigter.jpg');
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;

		.text {
			font-size: 30px;
			color: #fff;
			font-weight: 700;
		}
	}

	.midBox {
		position: relative;
		width: 100%;
		min-height: 50vh;

		.midFloatBox {
			overflow: hidden;
			width: 1200px;
			height: 100%;
			padding: 18px 15px 25px;
			margin: -40px auto 40px auto;
			background-color: #fff;
			box-shadow: 0 10px 15px rgba(39, 69, 167, .2);
			border-radius: 5px;

			.breadBox {
				// width: 1200px;
				margin: 3px 0 15px;
				font-size: 16px;
			}

			.tabBox {
				overflow: hidden;
				width: 100%;
				min-height: calc(100vh - 400px);
				margin: 0 auto;

				.code {
					text-align: center;
					height: 30px;
					background: #e2e2e2;
					line-height: 30px;
					font-size: 24px;
				}

				.layout-header {
					background-color: #ffffff;
					height: auto;
					padding-top: 30px;
				}

				//
				//.layout-content {
				//  background: url(../../assets/img/login-bg.png) center center no-repeat #ffffff;
				//  padding: 60px 0;
				//}

				.layout-footer {
					background-color: #ffffff;
				}

				.container {
					//width: 90%;
					//height: 80%;
					margin-left: auto;
					margin-right: auto;
					padding-top: 30px;
					//padding-top: 48%;
					//background: url(../../assets/img/login-image.png) center center no-repeat;
					//background-size: 80%;

				}

				.login-form {
					width: 70%;
					margin: 40px auto;

					h3 {
						margin: 0 0 30px;
						position: relative;
						padding-left: 15px;

						span {
							position: absolute;
							left: 0;
							display: block;
							height: 60%;
							top: 20%;
							width: 4px;
							background: #1890ff;
						}
					}

					.btnBB {
						width: 300px;
						margin: 0 auto;
					}

					:deep(.ant-form-item-label > label) {
						font-size: 16px;
					}
				}

				.ant-col-10 {
					margin-top: -43%;
					margin-left: 12%;
				}

				.title {
					font-size: 60px;
					font-weight: 500;
					margin: 40px 0;
				}



				.vcode-img {
					display: block;
					width: 100%;
					height: 50px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.login-img {
					display: block;
					width: 100%;
				}

			}
		}

	}
}

.banner-box {
    position: relative;

    img {
        width: 100%;
        height: 282px;
        object-fit: cover;
    }

    .text-box {
        position: absolute;
        top: 60px;
        width: 1200px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        left:50%;
        transform: translateX(-50%);

        .text1 {
            width: 100%;
            font-weight: 400;
            font-size: 20px;
            color: #9FBEFF;
            line-height: 50px;
        }

        .text2 {
            width: 100%;
            font-weight: 400;
            font-size: 40px;
            color: #FFFFFF;
            line-height: 50px;
            margin: 10px 0 30px 0;
        }

        .button {
            background: linear-gradient(90deg, #FF8F14, #FF5C0A);
            box-shadow: 0px 0px 1px 0px #FFFFFF;
            border-radius: 4px;
            color: #fff;
            width: 160px;
            height: 44px;
            text-align: center;
            line-height: 44px;
            font-size: 20px;
            cursor: pointer;
        }
    }
}
.breadBox {
    width: 100% !important;
    padding:0 !important;
    border-bottom: 1px solid #DEDEDE;

    .child {
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;

    }
}
:deep(.ant-list-lg .ant-list-item) {
	padding: 16px 8px;
}
</style>
<style>
.ant-modal-wrap {
	z-index: 998 !important;
}

.ant-modal-mask {
	z-index: 998 !important;
}
</style>
